module.exports = __webpack_public_path__ + "static/media/neosoft.89260031.png";